module.exports = __webpack_public_path__ + "static/img/1earth2.16dc9acc.png";